module.exports = __webpack_public_path__ + "static/img/20221213_03.12fe0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221213_03.png
// module id = M8hX
// module chunks = 0